import { giphyIndigo } from '@giphy/js-brand'
import React from 'react'
import { grid12 } from 'shared/util/grid'
import styled from 'styled-components'
import { GenericButton } from '../../buttons'
import Links from './footer-links'
import UploadButton from './upload-button'

const Container = styled.div`
    background: ${giphyIndigo};
    margin-top: 240px;
`

const Content = styled.div`
    display: flex;
    padding: 50px 0 70px;
    margin: 0 auto;
    text-align: center;
    width: ${grid12}px;
`

const Callout = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 70px;
    position: relative;
    width: 100%;

    h3 {
        font-size: 20px;
        font-weight: bold;
        margin: 0 0 10px;
        text-align: center;
    }

    p {
        font-size: 15px;
        line-height: 1.4;
        margin-bottom: 20px;
        text-align: center;

        strong {
            font-weight: bold;
        }
    }
`

const Peeker = styled.img`
    left: 50%;
    margin-left: -75px;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 150px;
`

const Upload = styled(UploadButton)`
    background: #000;
    margin-top: auto;
`

const ZoomMakerWelcomeFooter = () => {
    return (
        <Container>
            <Content>
                <Callout>
                    <Peeker src="/static/img/zoom-peeker-dude.gif" alt="" style={{ top: '-196px' }} />
                    <h3>Upload Your Own</h3>
                    <p>
                        Prefer to decorate with your own starter backdrop? Upload your own! We accept GIF, JPG, MOV, &
                        MP4 files. Go wild.
                    </p>
                    <Upload />
                </Callout>
                <Callout>
                    <Peeker src="/static/img/zoom-peeker-dog.gif" alt="" style={{ top: '-150px' }} />
                    <h3>Need some help?</h3>
                    <p>
                        Take a visit to our Help Center docs to learn more about how to make video calls more animated
                        with GIPHY Backdrop.
                    </p>
                    <GenericButton
                        as="a"
                        href="https://support.giphy.com/hc/en-us/articles/360046990732"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Learn More
                    </GenericButton>
                </Callout>
            </Content>
            <Links />
        </Container>
    )
}

export default ZoomMakerWelcomeFooter
